module.exports = __webpack_public_path__ + "img/prompt.97f86fba.svg";